<template>
<div class="clear sign-contract-card bcw">
  <div class="left sign-contract-card__avatar">
    <avatar-box v-if="clubInfo.logo" :avatar="clubInfo.logo" :auth="clubInfo.isCertification"></avatar-box>
    <avatar-box v-else :avatar="defaultLogo" :auth="clubInfo.isCertification"></avatar-box>
  </div>
  <div class="left sign-contract-card__info">
    <div class="fs2">{{ clubInfo.title }}</div>
    <div class="fs1 mtn c9">营业时间：{{ clubInfo.businessStartTime }}:00 - {{ clubInfo.businessEndTime }}:00</div>
    <div class="fs1 mtn c9">上班时间：<span v-if="clubInfo.workStartTime">{{ clubInfo.workStartTime }}:00</span> - <span v-if="clubInfo.workEndTime">{{ clubInfo.workEndTime }}:00</span></div>
    <div class="mtm sign-contract-card__btns">
      <van-button v-if="clubInfo.status == 'applying' && clubInfo.source == 'coach'" type="primary" @click="cancelApplyBtn = true" size="small" plain>取消申请</van-button>
      <div v-else-if="clubInfo.status == 'applying' && clubInfo.source == 'club'">
        <van-button type="warning" @click="refusedBtn = true" size="small" plain>拒绝签约</van-button>
        <van-button type="primary" @click="cancelSign('agreed')" size="small">同意签约</van-button>
      </div>
      <van-button v-else-if="clubInfo.status == 'agreed'" type="primary" size="small" @click="cancelBtn = true" plain> 取消签约</van-button>
      <van-button v-else-if="clubInfo.status == 'refused'" type="primary" size="small" @click="applySign(clubInfo.id)">再次申请</van-button>
      <!-- 搜索结果显示 -->
      <van-button v-else type="primary" size="small" @click="applySign(clubInfo.id)">申请签约</van-button>
    </div>
  </div>
  <van-dialog
    v-model="cancelBtn"
    title="确定要取消签约吗？"
    confirm-button-text=""
    cancel-button-text="再想想"
    @confirm="cancelSign('canceled')"
    show-cancel-button>
    <div style="padding:.2rem .15rem">
      <textarea v-model="refusedReason" placeholder="请输入原因" rows="2" class="van-field__control"></textarea>
    </div>
  </van-dialog>
  <van-dialog
    v-model="cancelApplyBtn"
    title="确定要取消申请吗？"
    confirm-button-text=""
    cancel-button-text="再想想"
    @confirm="cancelSign('cancelApply')"
    show-cancel-button>
    <div style="padding:.2rem .15rem">
      <textarea v-model="refusedReason" placeholder="请输入原因" rows="2" class="van-field__control"></textarea>
    </div>
  </van-dialog>
  <van-dialog
    v-model="refusedBtn"
    title="确定要拒绝签约吗？"
    confirm-button-text=""
    cancel-button-text="再想想"
    @confirm="cancelSign('refused')"
    show-cancel-button>
    <div style="padding:.2rem .15rem">
      <textarea v-model="refusedReason" placeholder="请输入原因" rows="2" class="van-field__control"></textarea>
    </div>
  </van-dialog>
</div>
</template>
<script>
import Vue from 'vue';
import {
  Button,
  Toast,
  Dialog,
  Field
} from 'vant';
Vue.use(Button).use(Toast).use(Dialog).use(Field);
import AvatarBox from '@/components/AvatarBox';
export default {
  inject:['reload'],  //注入reload方法
  name: 'SignContractCard',
  components: {
    AvatarBox
  },
  props: {
    clubInfo: { // 俱乐部信息
      type: Object,
      required: true,
      default: {},
    }
  },
  data() {
    return {
      status: true, // 当前是否签约状态
      cancelBtn: false, // 取消申请层显示状态
      cancelApplyBtn: false,
      refusedBtn: false,
      confirmTitle: '确定要取消吗？', // 弹层标题
      refusedReason: '', // 理由
      defaultLogo:'https://www.buole.com/assets/v2/img/buole_icon.jpg'
    }
  },
  methods: {
    applySign: function(id) {
      let _this = this
      // 申请签约
      this.$http.post('club_coach/applySign', {
        targetId: id
      }).then(res => {
        if (res.data.code != 0) {
          Toast.fail(res.data.message)
        } else {
          this.clubInfo.isSign = 1
          Toast({
            message:'已通知，请等待对方同意',
            duration:1000
          })
          setTimeout(function(){
            _this.reload()
          }, 1000) 
        }
      })
    },
    cancelSign: function(s){
      let _this = this
      // 取消签约
      this.$http.post('club_coach/changeStatus',{
        status: s,
        id: this.clubInfo.id,
        refusedReason: this.refusedReason
      }).then(res => {
        if(!res.data.code){
          if(s=='canceled' || s=='cancelApply'){
            Toast({
              message:'已取消',
              duration:1000
            })
            setTimeout(function(){
              _this.reload()
            }, 1000)
          }else if(s=='agreed'){
            Toast({
              message:'签约成功',
              duration:1000
            })
            setTimeout(function(){
              _this.reload()
            }, 1000)
          }else if(s=='refused'){
            Toast({
              message:'已拒绝',
              duration:1000
            })
            setTimeout(function(){
              _this.reload()
            }, 1000)
          }            
        }else{
          Toast.fail(res.data.message)
        }
      })
    }
  }
}
</script>
<style lang="less">
.sign-contract-card {
    padding: 0.1rem 0.15rem;
    border-bottom: 1px solid #f6f6f6;
    &__btns {}
}
</style>



// WEBPACK FOOTER //
// src/components/SignContractCard.vue